module.exports = __webpack_public_path__ + "static/media/new-new-matplotlib.be9062be.svg";